export const converTo = (value: string, type: string): string | number | boolean => {
    let val: string | number | boolean = value;

    switch (type) {
        case "string":
            val = String(value);
            break;
    
        case "number":
            val = isNaN(Number(value)) ? 0 : Number(value);
        break;

        case "boolean":
            val = value === "true" ? true : false;
        break;
    }

    return val;
}